import { render, staticRenderFns } from "./playlists.vue?vue&type=template&id=5c2bd2a9"
import script from "./playlists.vue?vue&type=script&lang=js"
export * from "./playlists.vue?vue&type=script&lang=js"
import style0 from "./playlists.vue?vue&type=style&index=0&id=5c2bd2a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports